module.exports = __webpack_public_path__ + "img/hero-our-plan-mobile@2x.64dfbd59.jpg";